import { getExternalProductStatus } from '@app/shared/lib'

import type { ExternalProductsListItemDto } from '@app/api/routes/externalProductsCatalog/dtos'
import type { ExternalProductsListItemDataSource, GeneralExternalProduct } from '@app/types/dataSource'

export const getExternalProductsListItemDataFromResponse = (
  response?: ExternalProductsListItemDto
): ExternalProductsListItemDataSource | undefined => {
  if (!response) return

  const generalProductResponse = response.generalProduct

  const generalProductExist = !!response.isMatchedWithProduct && !!generalProductResponse

  const getGeneralProductInfo = (): GeneralExternalProduct | null => {
    if (!generalProductExist) return null

    return {
      key: generalProductResponse?.id,
      name: generalProductResponse?.name,
      code: generalProductResponse?.code ?? ''
    }
  }

  const currentProductInfo = generalProductExist ? generalProductResponse : response

  return {
    key: response.id,
    name: currentProductInfo.name,
    status: getExternalProductStatus(response),
    isConfirmed: response.isConfirmed,
    isMatchedWithProduct: response.isMatchedWithProduct,
    isCHTM: currentProductInfo.isCHTM,
    isEPP: response.isEPP ?? false,
    trend: currentProductInfo.trend,
    purchasingGroup: currentProductInfo.purchasingGroup,
    commodityGroup: currentProductInfo.commodityGroup,
    category: currentProductInfo.category,
    subcategory: currentProductInfo.subcategory,
    generalProduct: getGeneralProductInfo(),
    manufacturer: currentProductInfo.manufacturer,
    regionManufacturer: response.regionManufacturer ?? '',
    brand: currentProductInfo.brand,
    categoryEggs: response.categoryEggs ?? '',
    shell: response.shell ?? '',
    productForm: response.productForm,
    packaging: response.packaging ?? '',
    fatContentOrFortress: response.fatContentOrFortress ?? '',
    volumeMl: currentProductInfo.volumeMl,
    volumeG: currentProductInfo.volumeG,
    volumePieces: currentProductInfo.volumePieces
  }
}
